import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";


var modal = document.getElementById("videoModal");

var span = document.getElementsByClassName("close")[0];

document.querySelectorAll("#openVideo").forEach(function(element) {
  element.addEventListener("click", function() {
    var videoId = this.getAttribute("data-id");
    var videoUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
    document.getElementById("videoFrame").setAttribute("src", videoUrl);
    modal.style.display = "block";
  });
});

span.onclick = function() {
  modal.style.display = "none";
  document.getElementById("videoFrame").removeAttribute("src"); // Remove the src attribute from the iframe
};

window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
    document.getElementById("videoFrame").removeAttribute("src"); // Remove the src attribute from the iframe
  }
};

function calculateRemainingDays() {
  var now = new Date();
  var targetDate = new Date(2024, 3, 4);
  var difference = targetDate.getTime() - now.getTime();
  var remainingDays = Math.ceil(difference / (1000 * 3600 * 24));
  return remainingDays;
}

function updateDisplay() {
  var remainingDays = calculateRemainingDays();
  var spanElement = document.getElementById("lp-bar-count");
  if(spanElement){
      spanElement.getElementsByTagName("span")[0].textContent = remainingDays;
  }

}

window.addEventListener("load", updateDisplay);

    gsap.registerPlugin(ScrollTrigger);

    function toggleClassOnScroll() {
      const landingPageBtn = document.querySelector('.lp-buy-now');
      const quickBuy = document.querySelector('.scrollBtn');

      function updateClass() {
        const isInViewport = ScrollTrigger.isInViewport(landingPageBtn);

        if (isInViewport) {
          quickBuy.classList.add('active');
        } else {
          quickBuy.classList.remove('active');
        }
      }

      // Initial check
      updateClass();

      // Set up ScrollTrigger
      ScrollTrigger.create({
        start: 0,
        end: "max",
        onUpdate: updateClass,
        markers: false,
      });
    }

    // Call the function when the DOM is ready
    document.addEventListener('DOMContentLoaded', toggleClassOnScroll);


const heroSwiper = new Swiper(".hero-swiper", {
  slidesPerView: "auto",
  spaceBetween: 10,
  preventClicks: false,
  // Responsive breakpoints
  loop: false,
  loopAdditionalSlides:3,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const cardsSwiper = new Swiper(".cards-swiper", {
  slidesPerView: "auto",
  effect: "cards",
  cardsEffect: {
    slideShadows: false,
    perSlideOffset: 5,
  },
  // Responsive breakpoints
  grabCursor: true,
});
const reviewSwiper = new Swiper(".reviews-swiper", {
  slidesPerView: "auto",
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  // Responsive breakpoints
  loop: true,
});

var thumbSlide = new Swiper(".thumbImg", {
  spaceBetween: 10,
  slidesPerView: "auto",
  freeMode: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
var featuredImg = new Swiper(".featuredImg", {
  slidesPerView: "auto",
  spaceBetween: 10,

  thumbs: {
    swiper: thumbSlide,
  },
});


function swiperStart() {
  thumbSlide.slideTo(0,500);
  featuredImg.slideTo(0,500);
}
var variantId;

const buyButton = document.querySelector(".lp-buy-now");

// Update the buy button URL with the selected variant ID
function updateBuyButton(variantId) {
  const baseUrl = "http://weedo-funwear-gmbh.myshopify.com/cart/";
  if(variantId !== undefined){
      buyButton.href = baseUrl + variantId + ":1";
  }
}


function updateVariants() {

  const variantInput = document.querySelectorAll(".variant-option input");

  variantInput.forEach((option) => {
  option.addEventListener("change", function () {
    const selectedVariantId = this.value;
    updateBuyButton(selectedVariantId);
  });

});
}



updateVariants();

updateBuyButton(variantId);

document.addEventListener("DOMContentLoaded", function () {
  var slideProducts = document.querySelectorAll(".slide-product-img");
  var selectedProduct = null;

  slideProducts.forEach(function (slideProduct) {
    var currentHandle = slideProduct.getAttribute("data-handle");


    if (slideProduct.classList.contains("selected") === true) {
      selectedProduct = slideProduct;
    }

    slideProduct.addEventListener("click", function (currentHandle) {
      var productHandle = this.getAttribute("data-handle");
                swiperStart();
      if (productHandle !== currentHandle) {
        this.classList.toggle("selected");
        selectedProduct.classList.toggle("selected");
        selectedProduct = this;

        fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((product) => {
            // Extract image URLs from the fetched data

            const titleElement = document.querySelector(".product__title");
            titleElement.textContent = product.title;

            
            if(window.Shopify.currency.active === 'EUR'){
                          function formatPrice(price) {
                // Füge die Dezimalstellen ein und trenne die Tausendertrennzeichen
                return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
              }
            // Update price
            const priceElement = document.querySelector(".price-badge");
            const priceSaveEl = document.querySelector(".lp-price_container .right .bold");

            
            var priceSave = 29900 - product.price;
            priceSaveEl.textContent = formatPrice(priceSave);
            priceElement.textContent = formatPrice(product.price);

              } else{
                                        function formatPrice(price) {
                // Füge die Dezimalstellen ein und trenne die Tausendertrennzeichen
                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price / 100);
              }
            // Update price
            const priceElement = document.querySelector(".price-badge");
            const priceSaveEl = document.querySelector(".lp-price_container .right .bold");

            
            var priceSave = 34900 - product.price;
            priceSaveEl.textContent = formatPrice(priceSave);
            priceElement.textContent = formatPrice(product.price);
              }

            const variantsContainer =
              document.querySelector(".product-variants");

            // Remove existing variant options
            const variantOptions =
              variantsContainer.querySelectorAll(".variant-option");
            variantOptions.forEach((option) => {
              option.remove();
            });

            // Update variants
            const firstAvailableVariant = product.variants.find(variant => variant.available);
            console.log(firstAvailableVariant)

            product.variants.forEach((variant, index) => {
              const variantOption = document.createElement("div");
              variantOption.className = "variant-option";
              variantOption.dataset.value = variant.title;
              if (!variant.available) {
                variantOption.classList.add("soldout"); 
              }

              const input = document.createElement("input");
              input.id = "variant-option-" + index;
              input.type = "radio";
              input.name = "option";
              input.value = variant.id;
              if (variant == firstAvailableVariant) {
                input.checked = true;
                variantId = variant.id;
                updateBuyButton(variantId);
              }
              if (!variant.available) {
                input.disabled = true;
              }

              const label = document.createElement("label");
              label.setAttribute("for", "variant-option-" + index);
              label.textContent = variant.title;

              variantOption.appendChild(input);
              variantOption.appendChild(label);
              variantsContainer.appendChild(variantOption);
              updateVariants(variantId);
              
            });



            const imageUrls = product.images.map((image) =>
              image.replace(/\?.*/, "")
            );

            // Get all swiper slides
            const swiperSlides = document.querySelectorAll(
              ".swiper-slide.featuredSlide"
            );
            const thumbSwiperSlides = document.querySelectorAll(
              ".swiper-slide.thumbSlide"
            );

            // Loop through each swiper slide and update the image URLs
            swiperSlides.forEach((slide, index) => {
              if (imageUrls[index]) {
                const img = slide.querySelector("img");
                if (img) {
                  // Update the src attribute with the new image URL
                  img.src = imageUrls[index];
                  img.srcset = imageUrls[index];
                  slide.style.display = "block";
                }
              } else {
                // If there's no corresponding image URL, remove the entire slide
                slide.style.display = "none";
              }
            });

            // Loop through each thumbSlide and update the image URLs
            thumbSwiperSlides.forEach((slide, index) => {
              if (imageUrls[index]) {
                const img = slide.querySelector("img");
                if (img) {
                  // Update the src attribute with the new image URL
                  img.src = imageUrls[index];
                  img.srcset = imageUrls[index];
                  slide.style.display = "block";
                }
              } else {
                // If there's no corresponding image URL, remove the entire slide
                slide.style.display = "none";
              }
            });




          })
          .catch((error) => {
            console.error(
              "There was a problem with the fetch operation:",
              error
            );
          });
      }
    });
  });
});



